export function getDataState(keepData, previousRenderParamsHash, dataLoaderState) {
    if (previousRenderParamsHash && dataLoaderState[previousRenderParamsHash] && keepData) {
        return dataLoaderState[previousRenderParamsHash].data;
    }
    return {
        hasData: false,
    };
}
//# sourceMappingURL=state-helper.js.map